import { createContext, useState, useContext, useEffect } from 'react'
import { useAuth } from './AuthProvider'
import { get } from '../api/auth'
import { post, del, put } from '../api/requests'
import {
  getFileUrl,
  getSubmissionUrl,
  getSubmissionsUrl,
  getSubmissionFilesUrl,
} from '../api/consts'

export const UploadProcessContext = createContext({})

export const useUploadProcess = () => {
  return useContext(UploadProcessContext)
}

export const UploadProcessProvider = ({ children }) => {
  const INIT_STATE = {
    id: null,
    submission_id: null,
    file: null,
    contract_option: null,
    author: null,
    draft: true,
  }
  const [uploadDone, setUploadDone] = useState(false)
  const [contractDone, setContractDone] = useState(false)
  const [metadataDone, setMetadataDone] = useState(false)
  const [authorNameDone, setAuthorNameDone] = useState(false)
  const [detailsDone, setDetailsDone] = useState(false)
  const { token, apiHost } = useAuth()

  const [data, setData] = useState(INIT_STATE)
  const setValues = (values) => {
    setData((prevData) => ({ ...prevData, ...values }))
  }

  useEffect(() => {
    if (!token) {
      setValues(INIT_STATE)
    }
  }, [token])

  useEffect(() => {
    return setUploadDone(data.id !== null)
  }, [data.id])

  useEffect(() => {
    setUploadDone(data.contract_option !== null)
    return setContractDone(data.contract_option !== null)
  }, [data.contract_option])

  useEffect(() => {
    setAuthorNameDone(data.author !== null)
  }, [data.author])

  useEffect(() => {
    setDetailsDone(!data.draft)
    setMetadataDone(!data.draft)
  }, [data.draft])

  const handleFileGetRequest = async (
    id,
    submission_id,
    onSuccess = () => {},
    onError = () => {}
  ) => {
    const url = getFileUrl(apiHost, submission_id, id)
    try {
      const result = await get(url, token)

      console.log('Success:', result)
      onSuccess(result)
    } catch (error) {
      onError(error)
    }
  }
  const createSubmission = async (title, onSuccess, onError) => {
    const result = await post(
      getSubmissionsUrl(apiHost),
      token,
      { title: title, draft: true },
      true
    )
    if (result['error']) {
      onError(result['error'])
    } else {
      console.log('Success:', result)
      onSuccess(result)
    }
    return true
  }
  const handleSubmissionGetRequest = async (
    submission_id,
    onSuccess,
    onError
  ) => {
    try {
      const result = await get(getSubmissionUrl(apiHost, submission_id), token)
      console.log('Success:', result)
      onSuccess(result)
    } catch (error) {
      onError(error)
    }
  }

  const handleSubmissionPostRequest = async (
    submission_id,
    data,
    onSuccess,
    onError
  ) => {
    const result = await put(
      getSubmissionUrl(apiHost, submission_id),
      token,
      data
    )
    if (!result.ok) {
      onError(result.statusText)
    } else {
      console.log('Success:', result)
      onSuccess(result)
    }
    return true
  }

  const handleFileUpload = (file, onSuccess = () => {}, onError = () => {}) => {
    const details = { file: file }
    const upload = async (url, token, data, onSuccess, onError) => {
      const result = await post(url, token, data)
      if (result['errors']) {
        onError(result['errors'])
      } else {
        onSuccess(result)
      }
    }

    // Use existing submission for file replace
    if (data.submission_id && data.draft) {
      upload(
        getSubmissionFilesUrl(apiHost, data.submission_id),
        token,
        details,
        onSuccess,
        onError
      )
    } else {
      createSubmission(
        file.name,
        async (submission) => {
          setValues({ submission_id: submission._id })
          upload(submission._links.files, token, details, onSuccess, onError)
        },
        onError
      )
    }
  }

  const handleFileDelete = async (onSuccess = () => {}, onError = () => {}) => {
    const url = getFileUrl(apiHost, data.submission_id, data.id)
    const response = await del(url, token)
    return response.ok ? onSuccess(response) : onError()
  }

  const value = {
    steps: [uploadDone, contractDone, metadataDone],
    tabs: [authorNameDone, detailsDone],
    data,
    setValues: setValues,
    uploadFile: handleFileUpload,
    deleteFile: handleFileDelete,
    getFile: handleFileGetRequest,
    getSubmission: handleSubmissionGetRequest,
    updateSubmission: handleSubmissionPostRequest,
  }
  return (
    <UploadProcessContext.Provider value={value}>
      {children}
    </UploadProcessContext.Provider>
  )
}
